import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentSystemNumbersRoute: RouteConfig = {
  path: 'systemNumbers',
  name: 'documentSystemNumbers',
  component: () =>
    import(/* webpackChunkName: "SystemNumbers" */ '@/views/mainRoute/document/details/SystemNumbers.vue'),
  beforeEnter: (to, from, next) => {
    store.commit('document/setId', tryParseInt(to.params.documentId));
    store
      .dispatch('document/get')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.DOCUMENT_CANNOT_GET }));
  }
};
